import { useTranslation } from 'react-i18next';
import { formatedDate, getDate } from "../../hooks/useCurrentDate";
import { getScoresHistoryThunk, getScoreDetailsThunk, fetchDailyScoreThunk, fetchReport } from "../../redux/features/scoresSlice";
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import InfiniteScroll from "react-infinite-scroll-component";

export default function GameResults({ state, subscription, cmp, progressReportEnabled, questionHistoryEnabled }) {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const [hasMore, setHasMore] = useState(true);
  const [openDetails, setOpenDetails] = useState(false);
  const [skip, setSkip] = useState(0);
  const limit = 10;
  const selectedProfile = useSelector(state => state.user.selectedProfile);
  const profiles = useSelector(state => state.user.profiles);
  const scoresHistory = useSelector(state => state.scores.data) || [];
  const dailyScore = useSelector(state => state.scores.dailyScore) || [];
  const scoreDetails = useSelector(state => state.scores.scoreDetails);
  const [loading, setLoading] = useState(false);

  const localScore = JSON.parse(localStorage.getItem('scoreStorage'))?.filter(item => item.score || item.date === getDate()) || [];
  const [reportData, setReportData] = useState(null);
  const [isPopupOpen, setIsPopupOpen] = useState(false);

  const getReport = async (id, date) => {
    try {
      setLoading(true);
      setIsPopupOpen(true);

      const res = await dispatch(fetchReport({ id, date }));

      if (fetchReport.fulfilled.match(res)) {
        setReportData(res.payload);
      } else {
        setIsPopupOpen(false);
      }

    } catch (err) {
      console.error(err);
      setIsPopupOpen(false);
    } finally {
      setLoading(false);
    }
  };

  const data = subscription
    ? Array.isArray(scoresHistory) ? scoresHistory : []
    : selectedProfile
      ? Array.isArray(dailyScore) ? dailyScore : []
      : Array.isArray(localScore) ? localScore : [];



  useEffect(() => {
    setSkip(0);
    setHasMore(true);

    if (subscription) {
      dispatch(getScoresHistoryThunk({
        userId: localStorage.getItem('user'),
        skip: 0
      }));
    } else if (selectedProfile?._id) {
      dispatch(fetchDailyScoreThunk({
        id: selectedProfile._id,
        skip: 0,
        limit
      }));
    }
  }, [subscription, selectedProfile]);

  const fetchMoreData = () => {
    if (loading || !hasMore) return;

    setLoading(true);

    if (subscription) {
      const nextSkip = skip + 100;

      dispatch(
        getScoresHistoryThunk({
          userId: localStorage.getItem('user'),
          skip: nextSkip
        })
      ).then(res => {
        if (!res.payload || res.payload.length === 0) {
          setHasMore(false);
        }
        setSkip(nextSkip);
        setLoading(false);
      });

    } else if (selectedProfile?._id) {
      const nextSkip = skip + limit;

      dispatch(
        fetchDailyScoreThunk({
          id: selectedProfile._id,
          skip: nextSkip,
          limit
        })
      ).then(res => {
        if (!res.payload || res.payload.length < limit) {
          setHasMore(false);
        }
        setSkip(nextSkip);
        setLoading(false);
      });
    }
  };


  return (
    <div className={`${cmp ? 'rounded-0' : 'rounded-[17px] lg:rounded-[22px]'} h-[100%] flex justify-center items-center w-full absolute z-[100]`}>
      <div className={`w-[80%] xl:h-[390px] lg:h-[340px] md:h-[295px] sm:h-[275px] h-[275px] rounded-[17px] lg:rounded-[22px] border-[3px] xl:border-[4px] border-[#4F9686] bg-[#FFF] overflow-hidden`}>
        <div id="scrollableTable" className='lang overflow-y-auto w-full h-full rounded-[17px] lg:rounded-[22px]'>
          {openDetails ? (
            <div>
              <div
                className='cursor-pointer text-[20px] mx-[10px] text-[#4F9686] font-fredokaOne'
                onClick={(e) => {
                  e.stopPropagation();
                  setOpenDetails(false);
                }}
              >
                back
              </div>
              {Object.entries(scoreDetails).map(([key, value]) =>
                Array.isArray(value) && value.length ? (
                  <fieldset key={key} className='mx-auto w-[90%] h-[100px] border-[1px] border-[#4F9686] rounded-[17px] overflow-y-hidden'>
                    <legend className='font-fredokaOne uppercase text-[#4F9686]'>{key}</legend>
                    {Object.values(value[0]).map((elem, idx) =>
                      typeof elem === 'object' ? <p key={idx}>{elem.name}-{elem.points}</p> : null
                    )}
                  </fieldset>
                ) : null
              )}
            </div>
          ) : !data.length && !loading ? (
            <div className="w-full h-full flex items-center justify-center text-[#4F9686] font-fredokaOne text-[16px] md:text-[18px] xl:text-[22px]">
              {t('noData2')}
            </div>
          ) : (
            <InfiniteScroll
              dataLength={data.length}
              next={fetchMoreData}
              hasMore={hasMore}
              scrollableTarget="scrollableTable"
            >
              <table className='w-full text-[#4F9686] font-fredokaOne [&>*:nth-child(even)]:bg-[#EFF4F4]'>
                <thead>
                  <tr className={`h-[37px] text-[12px] lg:h-[49px] ${state ? 'md:h-[41px] md:text-[14px] lg:text-[16px] xl:h-[54px] xl:text-[20px]' : 'md:h-[51px] md:text-[16px] lg:text-[18px] xl:h-[59px] xl:text-[24px]'}`}>
                    {data.length && Object.keys(data[0]).map(title => (
                      <th key={title} className='rounded-t-[17px] lg:rounded-t-[22px] capitalize sticky top-0 bg-[#FFF]'>{title}</th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {data.map((item, i) => (
                    <tr key={i} className={`${i % 2 ? 'text-[#BEBEBE]' : 'text-[#70BBAC]'}`}>
                      {Object.values(item).map((el, index) => (
                        <td
                          key={index}
                          className={`${index && 'cursor-pointer'} text-center`}
                          onClick={(e) => {
                            if (!selectedProfile?._id || !item.esc || !progressReportEnabled) return;
                            e.stopPropagation();
                            if (!subscription && selectedProfile?._id) {
                              getReport(selectedProfile._id, item.date)
                            }
                            else {
                              dispatch(getScoreDetailsThunk({
                                date: item.date,
                                profileId: profiles[index - 1]?._id,
                                userId: localStorage.getItem('user')
                              })).then(() => setOpenDetails(true))
                            }
                          }}
                        >
                          {el}
                        </td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>

              {loading && (
                <div className="absolute inset-0 z-10 flex items-center justify-center">
                  <img
                    src="/loading/loading.svg"
                    alt="Loading"
                    className="xl:w-[32px] lg:w-[28px] md:w-[24px] sm:w-[20px] w-[20px] animate-spin"
                  />
                </div>
              )}
            </InfiniteScroll>
          )}
        </div>
      </div>

      {isPopupOpen && (
        <div
          className="fixed inset-0 bg-black/50 flex items-center justify-center"
          onClick={() => setIsPopupOpen(false)} // клик по фону закрывает
        >
          <div
            className="bg-white p-6 rounded-lg w-[500px] max-h-[80vh] overflow-auto"
            onClick={(e) => e.stopPropagation()} // клик внутри popup не закрывает
          >
            {loading && <p>Loading...</p>}

            {!loading && reportData && (
              <pre className="text-sm">
                {JSON.stringify(reportData, null, 2)}
              </pre>
            )}
          </div>
        </div>
      )}
    </div >

  );
}
